/* eslint-disable import/prefer-default-export,import/no-unresolved */
import React from 'react';
import PropTypes from 'prop-types';
import VisaLogo from 'assets/images/visa-logo.svg';
import VisaLogoDark from 'assets/images/visa-logo-dark.svg';
import MastercardLogo from 'assets/images/mastercard-logo.svg';
import {
  CARD_NETWORKS,
  cardProviders,
  getCardCapabilities,
} from '../../../../screens/Card/constants';

export const CardLogo = ({ isVirtual = false, cardProvider = null, cardNetwork = '' }) => {
  const { usCardArtwork } = getCardCapabilities(cardProvider);

  if (usCardArtwork && cardNetwork === CARD_NETWORKS.VISA) {
    return (
      <div
        className="d-flex justify-content-center align-items-end"
        style={{ width: '4rem', height: '3rem' }}>
        <img src={!isVirtual ? VisaLogo : VisaLogoDark} alt="Visa" />
      </div>
    );
  }
  if (usCardArtwork && cardNetwork === CARD_NETWORKS.MASTERCARD) {
    return (
      <div
        className="d-flex justify-content-center align-items-end"
        style={{ width: '4rem', height: '3rem' }}>
        <img src={MastercardLogo} alt="Mastercard" />
      </div>
    );
  }

  if (cardProvider === cardProviders.MONAVATE) {
    return (
      <>
        <g clipPath="url(#clip0_16276_142648)">
          <g clipPath="url(#clip1_16276_142648)">
            <path d="M335.194 173.424H321.256V198.468H335.194V173.424Z" fill="#FF5F00" />
            <path
              d="M322.141 185.947C322.141 180.858 324.531 176.345 328.203 173.425C325.504 171.301 322.097 170.018 318.38 170.018C309.575 170.018 302.451 177.141 302.451 185.947C302.451 194.752 309.575 201.876 318.38 201.876C322.097 201.876 325.504 200.593 328.203 198.469C324.531 195.593 322.141 191.035 322.141 185.947Z"
              fill="#EB001B"
            />
            <path
              d="M354 185.947C354 194.752 346.876 201.876 338.071 201.876C334.354 201.876 330.947 200.593 328.248 198.469C331.965 195.549 334.31 191.035 334.31 185.947C334.31 180.858 331.921 176.345 328.248 173.425C330.947 171.301 334.354 170.018 338.071 170.018C346.876 170.018 354 177.186 354 185.947Z"
              fill="#F79E1B"
            />
          </g>
        </g>
      </>
    );
  }
  return (
    <>
      <path
        d="M291.998 162.41L296.763 181.135H302.294L310.9 159.449H305.29L299.868 174.172L297.64 162.651L291.998 162.41Z"
        fill="#FFFFFF"
      />
      <path d="M312.994 159.367L309.689 181.133H314.915L318.295 159.367H312.994Z" fill="#FFFFFF" />
      <path
        d="M333.666 164.569L334.434 160.01C332.809 159.393 331.094 159.068 329.364 159.051C326.596 159.051 320.603 160.891 320.603 166.249C320.603 171.607 328.053 171.851 328.053 174.81C328.053 177.769 321.369 177.452 319.371 175.533L318.529 180.253C318.529 180.253 321.525 181.454 324.214 181.454C326.902 181.454 333.593 180.814 333.593 173.853C333.593 167.77 326.137 168.971 326.137 165.291C326.137 165.291 326.904 161.611 333.667 164.568L333.666 164.569Z"
        fill="#FFFFFF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M339.04 181.135H333.277C333.277 181.135 340.31 163.943 341.04 161.932C341.811 159.811 343.498 159.611 343.498 159.611H348.109L352.692 181.107H347.697L347.109 178.013H340.04L339.04 181.135ZM341.575 173.533H346.264L344.497 165.531L341.575 173.533Z"
        fill="#FFFFFF"
      />
      <path
        d="M299.282 171.157L297.638 162.65C297.638 162.65 297.416 159.455 295.229 159.455H286.301V159.898C286.301 159.898 295.13 161.423 299.28 171.158L299.282 171.157Z"
        fill="#FFFFFF"
      />
      <path
        d="M330.447 194.635C330.447 196.049 330.062 197.131 329.292 197.881C328.527 198.627 327.423 199 325.982 199H323.609V190.434H326.234C327.566 190.434 328.601 190.803 329.339 191.541C330.078 192.279 330.447 193.311 330.447 194.635ZM329.392 194.67C329.392 193.553 329.111 192.711 328.548 192.145C327.99 191.578 327.158 191.295 326.052 191.295H324.605V198.139H325.818C327.005 198.139 327.898 197.848 328.496 197.266C329.093 196.68 329.392 195.814 329.392 194.67ZM335.289 199.117C334.34 199.117 333.59 198.828 333.039 198.25C332.492 197.672 332.219 196.869 332.219 195.842C332.219 194.807 332.473 193.984 332.981 193.375C333.492 192.766 334.178 192.461 335.037 192.461C335.842 192.461 336.479 192.727 336.947 193.258C337.416 193.785 337.65 194.482 337.65 195.35V195.965H333.227C333.246 196.719 333.436 197.291 333.795 197.682C334.158 198.072 334.668 198.268 335.324 198.268C336.016 198.268 336.699 198.123 337.375 197.834V198.701C337.031 198.85 336.705 198.955 336.397 199.018C336.092 199.084 335.723 199.117 335.289 199.117ZM335.025 193.275C334.51 193.275 334.098 193.443 333.789 193.779C333.484 194.115 333.305 194.58 333.25 195.174H336.607C336.607 194.561 336.471 194.092 336.197 193.768C335.924 193.439 335.533 193.275 335.025 193.275ZM342.663 192.473C343.507 192.473 344.161 192.762 344.626 193.34C345.094 193.914 345.329 194.729 345.329 195.783C345.329 196.838 345.092 197.658 344.62 198.244C344.151 198.826 343.499 199.117 342.663 199.117C342.245 199.117 341.862 199.041 341.514 198.889C341.171 198.732 340.882 198.494 340.647 198.174H340.577L340.372 199H339.675V189.883H340.647V192.098C340.647 192.594 340.632 193.039 340.6 193.434H340.647C341.1 192.793 341.772 192.473 342.663 192.473ZM342.522 193.287C341.858 193.287 341.38 193.479 341.087 193.861C340.794 194.24 340.647 194.881 340.647 195.783C340.647 196.686 340.798 197.332 341.098 197.723C341.399 198.109 341.882 198.303 342.546 198.303C343.143 198.303 343.589 198.086 343.882 197.652C344.175 197.215 344.321 196.588 344.321 195.771C344.321 194.936 344.175 194.312 343.882 193.902C343.589 193.492 343.135 193.287 342.522 193.287ZM348.367 199H347.394V192.578H348.367V199ZM347.312 190.838C347.312 190.615 347.367 190.453 347.476 190.352C347.585 190.246 347.722 190.193 347.886 190.193C348.042 190.193 348.177 190.246 348.29 190.352C348.404 190.457 348.46 190.619 348.46 190.838C348.46 191.057 348.404 191.221 348.29 191.33C348.177 191.436 348.042 191.488 347.886 191.488C347.722 191.488 347.585 191.436 347.476 191.33C347.367 191.221 347.312 191.057 347.312 190.838ZM352.863 198.314C353.035 198.314 353.201 198.303 353.361 198.279C353.521 198.252 353.648 198.225 353.742 198.197V198.941C353.637 198.992 353.48 199.033 353.273 199.064C353.07 199.1 352.887 199.117 352.723 199.117C351.48 199.117 350.859 198.463 350.859 197.154V193.334H349.939V192.865L350.859 192.461L351.27 191.09H351.832V192.578H353.695V193.334H351.832V197.113C351.832 197.5 351.924 197.797 352.107 198.004C352.291 198.211 352.543 198.314 352.863 198.314Z"
        fill="#FFFFFF"
      />
    </>
  );
};

CardLogo.propTypes = {
  isVirtual: PropTypes.bool,
  cardProvider: PropTypes.string,
  cardNetwork: PropTypes.string,
};
